export default {
	props: {
		label: {type:String, default:'Label',},
		minVal: {type:Number, default:0,},
		maxVal: {type:Number, default:1,},
		value:{type:Number, default:0},
	},
	data(){
		return {
		}
	},
	watch: {
		value:{
			immediate: true,
			handler(v){
			},
		},
	},
	computed:{
		innerValue:{
			get(){
				return this.value;
			},
			set(v){
				let newVal = parseInt(v);
				if(isNaN(newVal) || newVal<this.minVal){
					newVal = this.minVal;
				}
				else if(newVal>this.maxVal){
					newVal = this.maxVal;
				}
				this.$emit('input', newVal);
			},
		},
	},
	methods: {
		onDecrement(){
			this.innerValue -= 1;
			this.$emit('dec');
		},
		onIncrement(){
			this.innerValue += 1;
			this.$emit('inc');
		},
		onInput(ev){
			let tmp = parseInt(ev.target.value);
			this.innerValue = tmp;
			if(this.innerValue!=ev.target.value){
				ev.target.value = this.innerValue;
			}
		},
	},
	template: `
<div class="qit-inc-dec">
	<div class="label">{{label}}</div>
	<div class="control">
		<button type="button" @click="onDecrement" :disabled="innerValue<=minVal">-</button>
		<input :value="innerValue" @input="onInput" />
		<button type="button" @click="onIncrement" :disabled="innerValue>=maxVal">+</button>
	</div>
</div>
`,
}
